export const iconFontAwesomeFilesClone = (
	<i className="fa-solid fa-clone"></i>
);
